import { Box, FormControl, MenuItem, Select, SelectChangeEvent } from "@mui/material"
import { useCallback, useEffect, useState } from "react";

type MenuItem = {
    key: string,
    label: string,
    condition?: boolean
}
// const 

// const studentFilterOptions = {
//     ALL: "All Records",
//     ACTIVE: "Active Only",
//     EXPIRED: "Expired Only",
//     TSCREEN_AGE: "Kids ages 5-9",
//     TWEEN_AGE: "Kids ages 10-13",
//     TEEN_AGE: "Kids ages 14+"
// } as const;

// const staffFilterOptions = {
//     ALL: "All Records",
//     ACTIVE: "Active Only",
//     EXPIRED: "Expired Only",
// } as const
const filterOptions: MenuItem[] = [
    { key: "ALL", label: "All Records" },
    { key: "ACTIVE", label: "Active Only" },
    { key: "EXPIRED", label: "Expired Only" },
    { key: "TSCREEN_AGE", label: "Kids ages 5-9", condition: true },
    { key: "TWEEN_AGE", label: "Kids ages 10-13", condition: true },
    { key: "TEEN_AGE", label: "Kids ages 14+", condition: true }
]
// const tableFilterOptions = {
//     ...studentFilterOptions,
//     ...staffFilterOptions
// } as const
// type FilterOptions = typeof studentFilterOptions | typeof staffFilterOptions;

// export type TableFilterOption = keyof typeof tableFilterOptions;
export type TableFilterOption = typeof filterOptions[number]["key"];

export type TableFilterProps = {
    defaultValue?: TableFilterOption | null,
    onChange?: (value: TableFilterOption) => void
}

export default function TableFilter({ defaultValue = null, onChange }: TableFilterProps) {

    const [selectedOption, setSelectedOption] = useState<TableFilterOption>(defaultValue ?? "ALL");
    const _location = window.location.pathname.includes("users")
    const onSelectionChange = useCallback((option: TableFilterOption) => {
        return onChange ? onChange(option) : () => { };
    }, [selectedOption, onChange]);
    useEffect(() => {
        onSelectionChange(selectedOption);
    }, [selectedOption]);

    const handleSelectionChange = (event: SelectChangeEvent) => {
        const selectedValue = event.target.value as TableFilterOption;
        setSelectedOption(selectedValue);
    }
    return (
        <Box component="span">
            <FormControl fullWidth>
                <Select
                    id="table-filter"
                    value={selectedOption}
                    defaultValue={defaultValue ?? "ALL"}
                    onChange={handleSelectionChange}
                    sx={{ height: "40px" }}
                >
                    {filterOptions.filter(opt => opt.condition === undefined || (opt.condition === true && !_location))
                        .map(opt => (
                            <MenuItem key={opt.key} value={opt.key as TableFilterOption}>
                                {opt.label}
                            </MenuItem>
                        ))}
                </Select>
            </FormControl>
        </Box>
    )
}